import { BASE_URL } from '@/constants/config';

export const API_ENDPOINTS = {
  mzAuth: `${BASE_URL}auth/mz/authorize?authentication_backend=jwt`,
  mzAuthCallback: `${BASE_URL}auth/mz/callback`,
  lazyTable: `${BASE_URL}api/lazytable/`,
  dashboard: `${BASE_URL}api/dashboard/`,
};

export const errorMessage = "Something went wrong";

export const formTypeOptionsMap = {
  1: "Enquêtes d'insertion",
  2: "Enquêtes administratives annuelles"
};

export const formTypeOptions = Object.entries(formTypeOptionsMap).map(([formId, formName]) => {
  return {
    'label': formName,
    'value': formId
  }
});
